import { Plugin } from 'vue-fragment'
import installFragmentSiblingFix from '../global-declare-components/plugins/fragment-sibling-fix'
import Teleport from 'vue2-teleport';
import { parseThemeParams, applyThemeToElement } from '../../helpers/landing-theme'
import { initAgendaTimelines } from '../../helpers/agenda-timeline'

Vue.use(Plugin)
// Undo vue-fragment's over-broad sibling freeze (breaks vuedraggable / Vue patch).
installFragmentSiblingFix()

// Theme preview: apply theme/brand tokens passed via URL query params to
// <body> on load. Used by the settings "Customize theme" modal, which drives
// this page inside an iframe. Query params take priority — once the backend
// stores per-event custom themes, this stays as the live-preview override.
function initThemeFromQuery() {
  const state = parseThemeParams(window.location.search);
  if (Object.keys(state).length) {
    applyThemeToElement(document.body, state);
  }
}

// Agenda: the WYSIWYG agenda HTML is scanned for leading clock times
// ("11:10 – 12:30 PM", "11:10", …) and re-rendered as a timeline. Opt-in per
// page via `data-agenda-timeline` on the agenda container. Exposed on window so
// a blade can re-run it after swapping agenda markup.
window.initAgendaTimelines = initAgendaTimelines

function initLandingEnhancements() {
  initThemeFromQuery();
  initAgendaTimelines();
}

if (document.readyState !== 'loading') {
  initLandingEnhancements();
} else {
  document.addEventListener('DOMContentLoaded', initLandingEnhancements);
}

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent, true)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent, true)
  },
});

Vue.component('lp-teleport', Teleport)
Vue.component('lp-button', require('./ui/lp-button').default)
Vue.component('lp-modal', require('./ui/modals/lp-modal').default)
Vue.component('lp-drawer', require('./ui/modals/lp-drawer').default)

// Form field primitives — kept here too even though the plain landing page
// doesn't render them directly, matching this bundle's previous behavior
// exactly (near-zero cost, avoids any risk of an indirect usage regressing).
Vue.component('lp-input', require('./ui/forms/lp-input').default)
Vue.component('lp-select', require('./ui/forms/lp-select').default)
Vue.component('lp-checkbox', require('./ui/forms/lp-checkbox').default)
Vue.component('lp-radio', require('./ui/forms/lp-radio').default)
Vue.component('lp-qty-stepper', require('./ui/forms/lp-qty-stepper').default)
Vue.component('lp-attend-toggle-inline', require('./ui/lp-attend-toggle-inline').default)

// Presenter/faculty surfaces used by the landing page modals/drawers.
Vue.component('lp-avatar', require('./ui/lp-avatar').default)
Vue.component('lp-faculty-card', require('./ui/lp-faculty-card').default)
Vue.component('lp-presenter-list', require('./ui/lp-presenter-list').default)
Vue.component('lp-faculty-detail', require('./ui/lp-faculty-detail').default)
Vue.component('lp-session-detail', require('./ui/lp-session-detail').default)

// The page Vue instance (#event-landing-ui) is defined inline in the blade
// scripts section — see resources/views/site/event/{single,multiple}/landing_default/home.blade.php
//
// Registration and continue-registration are separate, full-page-navigation
// documents (not mounted here) — they load their own bundle, built from
// registration-entry.js, which additionally pulls in vee-validate, the Vuex
// store, and Stripe (all unused on this plain landing page). See that file's
// header comment for why this is a second webpack entry rather than a
// dynamic import() split.
